import { useForm, FormProvider } from "react-hook-form";
import { Button } from "../../../components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { FormControl, FormField, FormItem } from "@/src/components/ui/form";
import { useEffect } from "react";
import { useToast } from "@/src/components/ui/use-toast";
import { Textarea } from "@/src/components/ui/textarea";
import { EditBookingGoodToKnowForm } from "./goodToKnow.schema";
import { useBookingGoodToKnowMutation } from "@/src/lib/bookingGoodToKnowMutation";

type EditGoodToKnowProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  initialGoodToKnow: string | undefined;
  bookingId: string;
};

export const EditBookingGoodToKnowModal = ({ open, setOpen, initialGoodToKnow, bookingId }: EditGoodToKnowProps) => {
  const updateBookingGoodToKnow = useBookingGoodToKnowMutation(bookingId);
  const { toast } = useToast();

  const form = useForm<EditBookingGoodToKnowForm>({
    defaultValues: {
      goodToKnow: initialGoodToKnow || "",
    },
  });

  const { handleSubmit, control, reset } = form;

  useEffect(() => {
    reset({ goodToKnow: initialGoodToKnow || "" });
  }, [initialGoodToKnow, reset]);

  const onSubmit = (data: EditBookingGoodToKnowForm) => {
    const toastId = toast({
      description: "Updating good to know section...",
      variant: "default",
      duration: Infinity,
    }).id;

    updateBookingGoodToKnow.mutate(
      { goodToKnow: data.goodToKnow, toastId },
      {
        onSuccess: () => {
          setOpen(false);
        },
      },
    );
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(val) => {
        if (!val) {
          setOpen(false);
        }
      }}
    >
      <DialogContent className="max-w-[640px] max-h-[calc(100%-60px)] overflow-y-auto">
        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <DialogHeader>
              <DialogTitle className="text-3xl font-semi-bold">Edit good to know</DialogTitle>
            </DialogHeader>

            <div className="mt-4 space-y-4">
              <FormField
                control={control}
                name={`goodToKnow`}
                render={({ field }) => (
                  <FormItem className="flex items-center gap-2">
                    <FormControl>
                      <Textarea className="min-h-[200px]" {...field} placeholder={`Write boarding informations..`} />
                    </FormControl>
                  </FormItem>
                )}
              />
            </div>

            <DialogFooter className="flex mt-8 w-full !justify-between">
              <Button type="button" onClick={() => setOpen(false)} variant="outline">
                Cancel
              </Button>
              <Button type="submit" variant="default">
                Save
              </Button>
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};
